import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const errorsNotFoundRoute: InvariantJiraRoute = {
	name: 'errors-not-found',
	path: '/jira/:projectType(software|servicedesk|core)',
};
